import React from "react";
import HorizontalNav from "../navigation/HorizontalNav";
import RosterSubmissionsForm from "./RosterSubmissionsForm";

const RosterSubmissions = () => {
  return (
    <div>
      <HorizontalNav title={`Roster Submissions`} />
      <RosterSubmissionsForm />
    </div>
  );
};

export default RosterSubmissions;
